import React from 'react'

import ConnectedAutoSubProvider from 'components/ConnectedAutoSubProvider'
import { UserLayerProvider } from 'components/UserLayer'
import { PlayerLayerProvider } from 'components/PlayerLayer'

import { CircularProgress } from '@material-ui/core'

import { getUserInfo, addLink, removeLink, getGamePlayerProfile, getMatchPlayerProfile } from 'services/gamelogic'
import { withRouter, RouteComponentProps } from 'react-router'

interface Props {
}

type InjectedProps = Props & RouteComponentProps<{}>

const ScreenContainer: React.SFC<InjectedProps> = ({ children, history }) => {
  return (
    <UserLayerProvider
      getUserInfo={getUserInfo}
      addFriend={addLink}
      removeFriend={removeLink}
      onChallenge={(userId: string) => {
        history.push(`/games/create/match?type=private&challengeId=${userId}`)
      }}
    >
      <PlayerLayerProvider
        getGamePlayerProfile={getGamePlayerProfile}
        getMatchPlayerProfile={getMatchPlayerProfile}
      >
        <ConnectedAutoSubProvider>
          <React.Suspense fallback={<CircularProgress />}>{children}</React.Suspense>
        </ConnectedAutoSubProvider>
      </PlayerLayerProvider>
    </UserLayerProvider>
  )
}

export default withRouter(ScreenContainer)
try {
    // @ts-ignore
    ScreenContainer.displayName = "ScreenContainer";
    // @ts-ignore
    ScreenContainer.__docgenInfo = { "description": "", "displayName": "ScreenContainer", "props": { "wrappedComponentRef": { "defaultValue": null, "description": "", "name": "wrappedComponentRef", "required": false, "type": { "name": "Ref<any>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ScreenRoute/components/ScreenContainer/ScreenContainer.tsx#ScreenContainer"] = { docgenInfo: ScreenContainer.__docgenInfo, name: "ScreenContainer", path: "src/components/ScreenRoute/components/ScreenContainer/ScreenContainer.tsx#ScreenContainer" };
}
catch (__react_docgen_typescript_loader_error) { }